export const DownArrow = (props) => {
  const svgStyle = {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
  };
  return (
    <svg
      {...props}
      style={svgStyle}
      xmlns="http://www.w3.org/2000/svg"
      width="14.561"
      height="14"
      viewBox="0 0 14.561 14"
    >
      <path
        d="m9 18 6-6-6-6"
        transform="rotate(90 12 7.5)"
        data-name="Group 9130"
      />
    </svg>
  );
};
